import React, {useEffect, useState} from 'react';
import {Button} from 'react-bootstrap';
import FullScreenLoader from './full-screen';
import AssetKeyFormProp from './properties/asset-key-form';
import {LoadingStatusEnum} from '../enums/LoadingStatusEnum';
import TokenMetaDataView from './token-metadata-view';
import SandraJsAPI from "../services/sandraJsAPI";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function AssetKeyForm({
                          collectionId, setStatusMessage, handleClose, contract,
                      }: AssetKeyFormProp):
    React.ReactElement {
    const [loadingStatus, setLoadingStatus] = useState(LoadingStatusEnum.loaded);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorClass, setSetErrorClass] = useState('hide');
    const [assetKey, setAssetKey] = useState('');
    const [assetKeyPrev, setAssetKeyPrev] = useState('');
    const [tokenIdAsAssetId, setTokenIdAsAssetId] = React.useState(false);

    function validateForm() {
        if (!assetKey || assetKey?.trim().length === 0) {
            setErrorMessage('Please enter asset key id field');
            setSetErrorClass('error mb-4');
            return false;
        }

        setErrorMessage('');
        setSetErrorClass('hide');

        return true;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (validateForm()) {
            setLoadingStatus(LoadingStatusEnum.loading);
            SandraJsAPI.updateAssetKeyId({...contract, assetKeyId: assetKey}, collectionId).then((res) => {
                if (res.error) {
                    setStatusMessage(res.error.message, StatusMessageTypeEnum.error);
                } else {
                    setStatusMessage('Asset key updated successfully, please reload the page.', StatusMessageTypeEnum.success);
                }
                setLoadingStatus(LoadingStatusEnum.loaded);
                handleClose(false, 'success');
                window.scrollTo(0, 0);
            }).catch((error) => {
                setStatusMessage(error.message, StatusMessageTypeEnum.error);
                setLoadingStatus(LoadingStatusEnum.loaded);
                handleClose(false, 'error');
                window.scrollTo(0, 0);
            });
        }
    };

    const handleStatusMessage = (message: string, type: string) => {
        if (type === 'error') {
            setErrorMessage(message);
            setSetErrorClass('error mb-4');
        } else {
            setErrorMessage('');
            setSetErrorClass('hide');
        }
    };

    useEffect(() => {
        setAssetKey(contract.assetKeyId);
        setAssetKeyPrev(contract.assetKeyId);
    }, []);

    return (
        <div className="rounded add-process-box">
            {loadingStatus === LoadingStatusEnum.loading ? <FullScreenLoader/> : <div/>}
            <h5 className="p-1 mb-3">Add/Update Asset Key</h5>

            <div className={errorClass}>{errorMessage}</div>
            <div className="row">
                <div className="col-md-6">
                    <TokenMetaDataView
                        contract={contract}
                        setStatusMessage={handleStatusMessage}
                        onLoadingStatusChanged={
                            (status) => {
                                setLoadingStatus(status);
                            }
                        }
                    />
                </div>
                <div className="col-md-6">
                    <form onSubmit={handleSubmit}>
                        <h5>What is Asset key id?</h5>
                        <h6 className="mb-3">
                            Asset key id will be used to get asset id from metadata information, you can load
                            a metadata information for any token id of this contract from the chain and use it
                            to check the asset key.
                        </h6>
                        <div className="mb-3">
                            <div>
                                <span className="me-2  form-label fw-bold"> Collection Id:</span>
                                <span>{collectionId}</span>
                            </div>
                        </div>
                        <label htmlFor="checkTokenIdAsAssetId" className="form-label w-100">
                            <input
                                id="checkTokenIdAsAssetId"
                                type="checkbox"
                                checked={tokenIdAsAssetId}
                                className=""
                                onChange={(e) => {
                                    setTokenIdAsAssetId(e.target.checked);
                                    if (e.target.checked) {
                                        setAssetKey('#TOKENID#');
                                    } else {
                                        setAssetKey(assetKeyPrev);
                                    }
                                }}
                            />
                            <span className="ps-2">Use Token id as asset id. </span>
                        </label>
                        <label htmlFor="assetKey" className="form-label w-100">
                            Asset Key ID
                            <input
                                type="text"
                                id="assetKey"
                                disabled={tokenIdAsAssetId}
                                className="form-control mt-1 d-block"
                                value={assetKey}
                                onChange={(e) => {
                                    setAssetKey(e.target.value);
                                }}
                            />
                            {tokenIdAsAssetId ?
                                <span className="text-sm-light fst-italic p-1 d-block">Token id will be used as asset id.</span> : ''}
                        </label>
                        <div className="text-end">
                            <button type="submit" className="btn btn-dark me-2 ">Submit</button>
                            <Button
                                className="btn btn-light "
                                variant="primary"
                                onClick={() => {
                                    handleClose(false, 'close');
                                }}
                            >
                                Close
                            </Button>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    );
}

export default AssetKeyForm;
